import { zPhone } from '@/common';
import z from 'zod';

export const mepContactSchema = z.object({
  name: z.string({ required_error: 'Name is required' }).max(50).min(1, 'Name is required'),
  phoneNumber: zPhone,
});
